@if (isLoading()) {
  <m-skeleton width="100%" height="290px"></m-skeleton>
} @else if (!isDataAvailable()) {
  <m-not-available></m-not-available>
} @else {
  <m-table
    [columns]="table().columns"
    [value]="table().values"
    [footerData]="table().footer">
    <ng-template #customBody let-row>
      <tr>
        <ng-container *ngFor="let col of table().columns">
          <td [ngClass]="col?.class">
            <ng-container
              *ngIf="
                col.field === 'tactic' && row['channel'] && row['tactic'];
                else defaultCell
              ">
              <a
                class="context-modal-link b2 cursor-pointer text-blue-600"
                [routerLink]="[]"
                [queryParams]="{
                  modal: 'tactic',
                  channel: row['channel'],
                  tactic: row['tactic'],
                }"
                queryParamsHandling="merge">
                {{ row["tactic"] }}
              </a>
            </ng-container>
            <ng-template #defaultCell>
              @if (
                row[col.field] | formatOmniValue: col.field : viewType();
                as omniDisplay
              ) {
                <m-tooltip
                  [content]="omniDisplay.tooltipContent"
                  position="top"
                  [tooltipOptions]="{
                    positionTop: -8,
                    positionLeft: -42,
                    tooltipStyleClass: 'm-tooltip',
                  }">
                  <span [class]="omniDisplay.iconClass">
                    {{ omniDisplay.icon }}
                  </span>
                </m-tooltip>
              } @else {
                <div>{{ row[col.field] }}</div>
              }
            </ng-template>
          </td>
        </ng-container>
      </tr>
    </ng-template>
  </m-table>
}
